module.exports = __webpack_public_path__ + "img/users_black_icon.7347486b.svg";